import VistaprintAuth from '@vp/auth';
import axios, { AxiosRequestConfig, AxiosPromise } from 'axios';
import { v4 as uuidv4 } from 'uuid';

axios.interceptors.request.use((config) => {
  if (config.headers && !config.url?.startsWith('https://siteflow.')) {
    config.headers['x-request-id'] = uuidv4();
  }
  return config;
});

const vpAccessTokenRequest = async <T>(config: AxiosRequestConfig): Promise<AxiosPromise> => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const auth = new (VistaprintAuth.WebAuth as any)();
  const authHeader = auth.getAuthorizationHeader();

  if (!authHeader) {
    // eslint-disable-next-line no-console
    console.error('no vp-access-token found');
    throw Error('no vp-access-token found');
  }
  const configWithAuthHeader = {
    ...config,
    headers: {
      ...config.headers,
      Authorization: authHeader,
    },
  };
  return axios(configWithAuthHeader) as AxiosPromise<T>;
};

export default axios;

export { vpAccessTokenRequest };
